module.exports = __webpack_public_path__ + "static/media/noImage.d7530297.png";